import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import {
	Cell,
	Legend,
	Pie,
	PieChart,
	ResponsiveContainer,
	Tooltip,
} from 'recharts';
import { ChartTooltip } from './chart-tooltip';

import { toCategoryTotals } from '../lib';

import styles from './charts.module.css';

export function ExpensesChart({ expenses, categories, currency }) {
	const intl = useIntl();
	const pieData = useMemo(
		() => toCategoryTotals(expenses, categories, currency),
		[expenses, categories, currency],
	);

	return (
		<div className={styles.card} tabIndex={-1} onFocus={e => e.target.blur()}>
			<h3 className={styles.cardTitle}>
				{intl.formatMessage({ id: 'FinPathDashboardCartID24' })}
			</h3>
			<div className={styles.pieChartWrapper}>
				<ResponsiveContainer width='100%' height='100%'>
					<PieChart>
						<Pie
							data={pieData}
							dataKey='value'
							innerRadius='44%'
							outerRadius='72%'
							paddingAngle={1}
							minAngle={5}
							isAnimationActive={false}
						>
							{pieData.map(entry => (
								<Cell key={entry.name} fill={entry.color} />
							))}
						</Pie>
						<Tooltip
							content={<ChartTooltip currency={currency} />}
							animationDuration={0}
						/>
						<Legend />
					</PieChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
}
